export class ApiUrlConstant {
    static baseUrl: string = process.env.REACT_APP_CD_API!;

    static userData = {
        getUserData: ApiUrlConstant.baseUrl + "api/UserData",
    }

    static timekeeper = {
        getTimeKeepersDetailbyTimekeeperId: ApiUrlConstant.baseUrl + "api/TimeKeeper/{0}/{1}/{2}",
    }

    static timeFinder = {
        getTimekeeperActivitiesAll: ApiUrlConstant.baseUrl + "api/TimeFinder/GetTimekeeperActivitiesAll",
        excludeTimeFinderActivity: ApiUrlConstant.baseUrl + "api/TimeFinder/ExcludeTimeFinderActivity"
    }

    static client = {
        getClients: ApiUrlConstant.baseUrl + "api/Client/LookupData",
        getClientDetails: ApiUrlConstant.baseUrl + "api/Client/GetAllClientsDetailsForClientIds",
        validateIfClientIdsUnaccessibleForUser: ApiUrlConstant.baseUrl + "api/BarrierCheck/Clients/ValidateUnaccessibleForUser",
        validateRestrictedClientForUser: ApiUrlConstant.baseUrl + "api/BarrierCheck/Client",
        validateRestrictedClientForTimekeeper: ApiUrlConstant.baseUrl + "api/BarrierCheck/Client/{0}/RestrictedForTimekeeper/{1}",
    }

    static matter = {
        getMatter: ApiUrlConstant.baseUrl + "api/Matter/LookupData",
        getMatterDetailsForClient: ApiUrlConstant.baseUrl + "api/Matter/Details/{0}/ForClient/{1}/{2}/{3}",
        getMatterDetailsByMatterId: ApiUrlConstant.baseUrl + "api/Matter/Details",
        validateIfMatterIdsUnaccessibleForUser: ApiUrlConstant.baseUrl + "api/BarrierCheck/Matters/ValidateUnaccessibleForUser",
        validateRestrictedMatterForUser: ApiUrlConstant.baseUrl + "api/BarrierCheck/Matter",
        validateRestrictedMatterForTimekeeper: ApiUrlConstant.baseUrl + "api/BarrierCheck/Matter/{0}/{1}/RestrictedForTimekeeper/{2}",
    }

    static settings = {
        getSettings: ApiUrlConstant.baseUrl + "api/CarpeConfiguration",
        getUserDefaultConfigurationDetails: ApiUrlConstant.baseUrl + "api/UserConfiguration",
    }

    static userCode = { 
        getUDCdata: ApiUrlConstant.baseUrl + "api/UserCode/{0}/Lookup?codeset={1}&q={2}&start={3}&len={4}&parent={5}",
        getUDCObject: ApiUrlConstant.baseUrl + "api/UserCode/{0}?codeId={1}&codeset={2}",
    }

    static validationData = {
        getRoundingAndBillableValue: ApiUrlConstant.baseUrl + "api/ValidationData/GetRoundingAndBillableValue",
        getLocalValidationRules: ApiUrlConstant.baseUrl + "api/ValidationRules?clientId={0}&matterId={1}&timekeeperId={2}"
    }

    static timeEntry = { 
        deleteTimeEntries: ApiUrlConstant.baseUrl + "api/TimeEntry/Delete",
        getTimeEntries: ApiUrlConstant.baseUrl + "api/TimeEntry/Day/{0}/Tkpr/{1}?format={2}&rndInc={3}&endDate={4}&isSmartTimer={5}",
        addTimeEntry: ApiUrlConstant.baseUrl + "api/TimeEntry/AddTimeEntry",
        getLocalAllowBillableOverrideInfo: ApiUrlConstant.baseUrl + "api/BillableState?clientId={0}&matterId={1}&tkprId={2}",
    }

    static spellCheck = {
        getMisspelledWords: ApiUrlConstant.baseUrl + "api/SpellCheck/MisspelledWords",
        getSuggestions: ApiUrlConstant.baseUrl + "api/SpellCheck/Suggestions",
        getCustomSuggestions: ApiUrlConstant.baseUrl + "api/SpellCheck/CustomSuggestions",
        updateUserDictionary: ApiUrlConstant.baseUrl + "api/SpellCheck/UserDictionary",
    }
}